module.exports = __webpack_public_path__ + "public/img/Membuat Laporan Keuangan dengan Microsoft Excel.45e8c7d4.png";